import { HelpCircle, PlusCircle, MinusCircle } from "lucide-react"
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "../components/ui/card"
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../components/ui/accordion"

export default function FAQPage() {
  return (
    <div className="container mx-auto px-4 py-8">
      <div className="text-center mb-12 relative">
        <h1 className="text-4xl font-bold font-display bg-gradient-to-r from-[#FF6B00] via-[#FF9A3D] to-[#FFD700] bg-clip-text text-transparent drop-shadow-glow mb-4">
          Frequently Asked Questions
        </h1>
        <p className="text-blue-100/80 max-w-2xl mx-auto">
          Find answers to common questions about CaseRTP and what we do
        </p>
      </div>

      <div className="max-w-4xl mx-auto">
        <Card className="!bg-[#1A1D21]/40 border-[#2A2D31]/50 backdrop-blur-sm overflow-hidden !text-white">
          <CardHeader className="border-b border-[#2A2D31]/50 pb-4">
            <CardTitle className="font-display text-2xl flex items-center">
              <HelpCircle className="mr-2 h-6 w-6 text-[#FF6B00]" />
              About CaseRTP
            </CardTitle>
            <CardDescription className="text-blue-100/70">
              Learn more about our platform
            </CardDescription>
          </CardHeader>
          <CardContent className="pt-6">
            <CustomAccordion items={faqItems} />
          </CardContent>
        </Card>
      </div>
    </div>
  )
}

function CustomAccordion({ items }) {
  return (
    <Accordion type="single" collapsible className="w-full">
      {items.map((item) => (
        <AccordionItem
          key={item.id}
          value={item.id}
          className="border-b border-[#2A2D31]/50 last:border-0 overflow-hidden group"
        >
          <AccordionTrigger className="py-3 text-left hover:no-underline group-data-[state=open]:text-[#FF6B00] transition-colors duration-200">
            <div className="flex justify-between items-center w-full pr-2">
              <span className="text-lg font-medium font-display">{item.question}</span>
              <div className="flex-shrink-0 ml-4 text-[#FF6B00] opacity-0 group-hover:opacity-100 group-data-[state=open]:opacity-100 transition-opacity duration-200">
                <PlusCircle className="h-5 w-5 hidden group-data-[state=closed]:block" />
                <MinusCircle className="h-5 w-5 hidden group-data-[state=open]:block" />
              </div>
            </div>
          </AccordionTrigger>
            <AccordionContent className="overflow-hidden text-blue-100/80">
              <div className="pl-2 border-l-2 border-[#FF6B00]/30 ">
                {item.answer}
              </div>
            </AccordionContent>

        </AccordionItem>
      ))}
    </Accordion>
  )
}

const faqItems = [
  {
    id: "faq-1",
    question: "What does this site do?",
    answer:
      "We compare the actual drop odds for cases across different third-party sites, so you can see where you've got the best shot at pulling something good. No guessing, just straight up data.",
  },
  {
    id: "faq-2",
    question: "Are the odds accurate?",
    answer:
      "We keep them updated using info from the sites themselves or public case data. Odds can change though, so if you're about to open a case, always double check on the site too.",
  },
  {
    id: "faq-3",
    question: "Do you sell or open cases?",
    answer:
      "Nope, we don't run a case-opening site. We're just here to help you make smarter choices. Think of us as your case opening cheat sheet, clear odds, no BS.",
  },
  {
    id: "faq-4",
    question: "Can you trust these case sites?",
    answer:
      "Some are trustworthy, some are a bit sketchy. We stick to known platforms, but always do your own research, look for provably fair systems, real reviews, and don't spend what you can't afford to lose.",
  },
]
